module.exports = __webpack_public_path__ + "static/media/wmsui32_3936.da98b097.ico";